import { Text, View } from '@react-pdf/renderer';

const Hobbies = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<Text style={styles.heading}>{headerTitle}</Text>
			<View style={styles.skills}>
				{data?.map((res: any) => (
					<View key={res} style={styles.skillsBox}>
						<Text style={styles.skillsText}>{res}</Text>
					</View>
				))}
			</View>
		</View>
	);
};

export default Hobbies;
